<template>
  <div :class="['with-sidebar', reversed && 'with-sidebar__reversed']">
    <div class="with-sidebar__content">
      <slot name="content"></slot>
    </div>

    <div class="with-sidebar__sidebar">
      <slot name="sidebar"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    reversed?: boolean;
  }>(),
  {
    reversed: false,
  }
);
</script>

<style lang="scss" scoped>
.with-sidebar {
  // Stacked (content/sidebar full-width, one above the other) below 960px -
  // side-by-side flex:2/flex:1 columns with no breakpoint at all forced both
  // to share one row's width even on a 375px screen, pushing content wider
  // than the viewport (horizontal scroll) and squeezing the sidebar off to
  // the side where it was effectively invisible.
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 0 12px;

  // `reversed` puts the sidebar visually first (above, on mobile / left, on
  // desktop) - column-reverse mirrors row-reverse's DOM-order flip.
  &__reversed {
    flex-direction: column-reverse;
  }

  @media screen and (min-width: 960px) {
    flex-direction: row;
    justify-content: space-between;
    column-gap: 20px;
    row-gap: 0;
    height: calc(95vh - 126px);
    padding: 0 30px;

    &__reversed {
      flex-direction: row-reverse;
    }
  }

  &__content {
    @media screen and (min-width: 960px) {
      flex: 2;
    }
  }

  &__sidebar {
    @media screen and (min-width: 960px) {
      flex: 1;
    }
  }

  &__content,
  &__sidebar {
    width: 100%;
    min-width: 0;
    border-radius: 20px;
    background: #fff;
  }
}
</style>
